<template>
  <button
    :class="[
      variant ? `base-button-variant-${variant}` : '',
    ]"
  >
    <slot />
  </button>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { Style } from '@/models/style';

export default defineComponent({
  name: 'BaseButton',
  props: {

    /**
     * スタイルバリアント
     */
    variant: {
      type: String,
      default: '',
    },

    /**
     * ボタンのスタイル
     */
    buttonStyle: {
      type: Object as PropType<Style>,
      required: false,
      default: () => ({}),
    },
  },
});
</script>
